import { useCallback, useState } from 'react';
import icSucess from '../../assets/img/ic-celebration-circle.svg';
import ProfileUpdateSuccessModal from './ProfileUpdateSuccessModal';

const ACCOUNT_SUCCESS_CONTENT = {
    password: { title: 'Password changed successfully', message: 'Your password has been changed successfully.' },
    deactivated: { title: 'Account deactivated', message: 'Your account has been deactivated successfully.' },
    activated: { title: 'Account activated', message: 'Your account has been activated successfully.' },
};

// Shared by every Profile route: holds which account-action success (if any) is showing.
export const useProfileAccountSuccess = () => {
    const [kind, setKind] = useState(null);
    const showAccountSuccess = useCallback((nextKind) => setKind(nextKind), []);
    const hideAccountSuccess = useCallback(() => setKind(null), []);
    return { accountSuccessKind: kind, showAccountSuccess, hideAccountSuccess };
};

const ProfileAccountSuccessModal = ({ kind, onHide }) => {
    const content = ACCOUNT_SUCCESS_CONTENT[kind];
    // Keep the last content mounted-free: render nothing once cleared.
    if (!content) return null;
    return <ProfileUpdateSuccessModal show onHide={onHide} icon={icSucess} title={content.title} message={content.message} />;
};

export default ProfileAccountSuccessModal;
